module.exports = __webpack_public_path__ + "img/front centered zipper length.b490e23b.png";